import { User } from "./user.model";

export class AuthResponse {
  static EXPIRE_THRESHOLD_SECONDS = 86400; // a day before token expire, it is eligable for refresh

  jwt!: string;
  tokenType!: string;
  expiresIn!: number;
  timestamp!: number;

  constructor(data?: Partial<AuthResponse>) {
    if (data) {
      Object.assign(this, data);
    }
  }

  get payload(): any | null {
    if (!this.jwt) {
      return null;
    }

    try {
      const base64 = this.jwt.split('.')[1];
      const json = atob(base64);
      return JSON.parse(json);
    } catch {
      return null;
    }
  }

  get user(): any | null {
    return this.payload?.user ?? null;
  }

  get currentUserId(): number | null {
    return this.user?.id ?? null;
  }

  get instanceId(): number | null {
    return this.user?.instanceId ?? null;
  }

  isExpired(): boolean {

    const tokenAge = (Date.now() - this.timestamp) / 1000;
    const remaining = (this.expiresIn * 60) - tokenAge;

    return remaining <= 0;
  }

  isExpireSoon(): boolean {

    const tokenAge = (Date.now() - this.timestamp) / 1000;
    const remaining = (this.expiresIn * 60) - tokenAge;

    return remaining > 0 && remaining <= AuthResponse.EXPIRE_THRESHOLD_SECONDS;
  }

  get primaryRole(): string | null {
    return this.user?.primaryRole ?? null;
  }

  isAdmin(): boolean {
    return this.primaryRole === User.ROLE_ADMIN;
  }

  isInstanceConfigurator(): boolean {
    return this.primaryRole === User.ROLE_INSTANCE_CONFIGURATOR;
  }

  canSwitchInstances(): boolean {
    return this.isAdmin() || this.isInstanceConfigurator();
  }

  isClientAdmin(): boolean {
    return this.primaryRole === User.ROLE_CLIENT_ADMIN;
  }

  isMarketer(): boolean {
    return this.primaryRole === User.ROLE_MARKETER;
  }

  isPropertyManager(): boolean {
    return this.primaryRole === User.ROLE_PROPERTY_MANAGER;
  }
}
